export default "__VITE_ASSET__xQCazs2e__"